/* eslint import/prefer-default-export: 0 */
import moment from 'moment';
import _ from 'lodash';

import common from '@common';
import * as ScheduleHelpers from '../../schedule/helpers';
import * as t from './action_types';
import { getScheduleInitialState, getTotalPages } from './helpers';
import { PAGINATION_SETTINGS } from '../../schedule/constants';

const {
  calendar: {
    constants: { SCHEDULE_MODALS_NAMES },
  },
} = common;

const initialState = {
  ...getScheduleInitialState(),
  calendarVisible: false,
  expandAll: true,
  filtersVisible: true,
  fetchingProperties: true,
  fetchingReservations: true,
  fetchingTasks: true,
  fetchingDrafts: true,
  fetchingMonthly: true,
  searchQuery: '',
  modals: {
    date: moment(),
    modalName: SCHEDULE_MODALS_NAMES.NONE,
    propertyId: null,
    reservation: null,
    scheduledWorkflowId: null,
    taskId: null,
    taskDraftId: null,
    userId: null,
  },
  organizeModeFlag: false,
  pagination: {
    page: 0,
    perPage: PAGINATION_SETTINGS.PER_PAGE,
  },
  scheduleMounted: false,
  sortingOption: 'asc',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case t.SC_SET_EXPAND_ALL:
    case t.SC_SET_SUBJECT:
    case t.SC_SET_TYPE:
    case t.SC_SET_FILTERS_VISIBILITY:
    case t.SC_UPDATE_SEARCH_QUERY:
    case t.SC_SET_DISPLAYED_TASKS_IDS:
    case t.SC_SET_CALENDAR_VISIBILITY:
    case t.SC_SET_ORGANIZE_MODE_FLAG:
    case t.SC_SET_SCHEDULE_MOUNTED_FLAG:
    case t.SC_SET_SORTING_OPTION:
    case t.SC_SET_DISPLAYED_SCHEDULE_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    case t.SC_SET_FETCHING_FLAG: {
      const { key, value } = action.payload;
      const flagKey = `fetching${_.upperFirst(key)}`;

      return {
        ...state,
        [flagKey]: value,
      };
    }
    case t.SC_SET_ACTIVE_DATE: {
      const { mode } = state;
      const { activeDate } = action.payload;

      const dates = ScheduleHelpers.getActiveDateRange(activeDate, mode);

      return {
        ...state,
        activeDate,
        dates,
      };
    }
    case t.SC_SET_MODE: {
      const { activeDate } = state;
      const { mode } = action.payload;

      const dates = ScheduleHelpers.getActiveDateRange(activeDate, mode);

      return {
        ...state,
        dates,
        mode,
      };
    }
    case t.SC_PAGINATION_PREV_PAGE: {
      const { pagination } = state;
      const { page, perPage } = pagination;
      const { totalRecords } = action.payload;
      const totalPages = getTotalPages(page, perPage, totalRecords);

      const newPage = page === 0 ? totalPages - 1 : page - 1;

      return {
        ...state,
        pagination: {
          ...pagination,
          page: newPage,
        },
      };
    }
    case t.SC_PAGINATION_NEXT_PAGE: {
      const { pagination } = state;
      const { page, perPage } = pagination;
      const { totalRecords } = action.payload;
      const totalPages = getTotalPages(page, perPage, totalRecords);

      const newPage = page === totalPages - 1 ? 0 : page + 1;

      return {
        ...state,
        pagination: {
          ...pagination,
          page: newPage,
        },
      };
    }
    default:
      return state;
  }
};
